<script>
import { mapState } from 'vuex'
import { permissionChecker } from '@md/users/permissions'

export default {
  data() {
    return {
      cadastreAccessText: this._('Деталі оголошення недоступні. Будь ласка, зверніться до менеджера'),
    }
  },

  computed: {
    ...mapState('users/auth', ['user']),

    isAdmin() {
      const { TYPES } = this.$allPermissions.PROFILE
      const isAdmin = permissionChecker([TYPES.IS_ADMIN])

      return isAdmin
    },

    isInvestor() {
      const { TYPES } = this.$allPermissions.PROFILE
      const isInvestor = permissionChecker([TYPES.IS_INVESTOR])

      return isInvestor && !this.isAdmin
    },

    canCreateOrder() {
      return this.user.info.canCreateOrder
    },

    hasAccess() {
      const investorWithAccess = this.isInvestor && this.canCreateOrder

      return investorWithAccess || !this.isInvestor
    },
  },

  render() {
    return this.$scopedSlots.default({
      hasAccess: this.hasAccess,
      cadastreAccessText: this.cadastreAccessText,
    })
  },
}
</script>
